import { PhoneCall, ChevronRight, Star, Shield, Zap } from "lucide-react";

const CTA = () => {
  return (
    <section
      id="contact"
      className="py-20 px-6 bg-gradient-to-br from-green-100/70 via-white to-cyan-100/70"
    >
      <div className="max-w-6xl mx-auto text-center relative">
        {/* Card Container */}
        <div className="relative bg-white rounded-3xl p-12 border border-gray-200 shadow-xl overflow-hidden">
          
          {/* Background Illustration */}
          <img
            src="/image/people.png"
            alt="Business Communication Illustration"
            className="absolute inset-0 w-full h-full object-contain opacity-10 pointer-events-none"
          />

          {/* Content */}
          <div className="relative z-10">
            {/* Heading */}
            <h2 className="text-4xl lg:text-5xl font-extrabold mb-6 text-slate-800">
              Siap Meningkatkan{" "}
              <span className="bg-gradient-to-r from-green-600 to-cyan-500 bg-clip-text text-transparent">
                Komunikasi Bisnis?
              </span>
            </h2>
            <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto">
              Dapatkan konsultasi gratis dan demo produk IP Phone untuk kebutuhan
              perusahaan Anda
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button className="group flex items-center justify-center gap-2 bg-gradient-to-r from-green-600 to-cyan-500 hover:from-green-700 hover:to-cyan-600 px-8 py-4 rounded-xl font-semibold text-lg text-white transition-all duration-300 hover:scale-105 shadow-lg">
                Konsultasi Gratis
                <PhoneCall className="w-5 h-5 group-hover:rotate-12 transition-transform" />
              </button>
              <button className="group flex items-center justify-center gap-2 border-2 border-green-600 hover:bg-green-50 text-green-600 px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300">
                Demo Produk
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>

            {/* Features */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-emerald-400 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-md">
                  <Star className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">24/7 Support</h3>
                <p className="text-slate-600 text-sm">Dukungan teknis sepanjang waktu</p>
              </div>

              <div className="text-center">
                <div className="w-14 h-14 bg-gradient-to-r from-green-500 to-cyan-400 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-md">
                  <Shield className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Setup Mudah</h3>
                <p className="text-slate-600 text-sm">Instalasi dan konfigurasi cepat</p>
              </div>

              <div className="text-center">
                <div className="w-14 h-14 bg-gradient-to-r from-purple-500 to-pink-400 rounded-2xl mx-auto mb-4 flex items-center justify-center shadow-md">
                  <Zap className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-semibold text-lg mb-2 text-slate-800">Harga Fleksibel</h3>
                <p className="text-slate-600 text-sm">Paket sesuai kebutuhan bisnis</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;